import type { ReactElement, ReactNode } from 'react';
import { ComboboxBehaviorProvider, ComboboxTextsProvider } from '../ui-kit/Combobox/Combobox';
import { ConfirmProvider } from '../ui-kit/ConfirmDialog/ConfirmDialog';
import { FormMessagesProvider } from '../ui-kit/form/form';
import { useConfig, useT } from './di';

/**
 * Провайдеры ui-kit, которым нужны словари и конфигурация приложения: диалог подтверждения,
 * тексты ошибок форм по кодам, тексты и поведение автокомплита. Общие для приложения и витрины
 * Storybook.
 */
export function UiProviders({ children }: { children: ReactNode }): ReactElement {
  const { t, te } = useT();
  const { ui } = useConfig();
  return (
    <FormMessagesProvider messageOf={te}>
      <ConfirmProvider cancelLabel={t('common.cancel')} closeLabel={t('common.close')}>
        <ComboboxTextsProvider
          texts={{
            loading: t('common.combobox.loading'),
            empty: t('common.combobox.empty'),
            failed: t('common.combobox.failed'),
            retry: t('common.retry'),
            clear: t('common.combobox.clear'),
            remove: t('common.remove'),
          }}
        >
          <ComboboxBehaviorProvider behavior={{ searchDelayMs: ui.search.delayMs, loadMoreEdgePx: ui.combobox.loadMoreEdgePx }}>{children}</ComboboxBehaviorProvider>
        </ComboboxTextsProvider>
      </ConfirmProvider>
    </FormMessagesProvider>
  );
}
